var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 9.00002H3.99992M5.33325 7.00002H3.99992M1.33325 4.66669H14.6666M1.33325 6.00002C1.33325 3.48602 1.33325 2.22869 2.11459 1.44802C2.89592 0.667354 4.15259 0.666687 6.66659 0.666687H9.33325C11.8473 0.666687 13.1046 0.666687 13.8853 1.44802C14.6659 2.22935 14.6666 3.48602 14.6666 6.00002C14.6666 8.51402 14.6666 9.77135 13.8853 10.552C13.1039 11.3327 11.8473 11.3334 9.33325 11.3334H6.66659C4.15259 11.3334 2.89525 11.3334 2.11459 10.552C1.33392 9.77069 1.33325 8.51402 1.33325 6.00002ZM9.33325 8.00002C9.33325 7.37135 9.33325 7.05735 9.52859 6.86202C9.72392 6.66669 10.0379 6.66669 10.6666 6.66669C11.2953 6.66669 11.6093 6.66669 11.8046 6.86202C11.9999 7.05735 11.9999 7.37135 11.9999 8.00002C11.9999 8.62869 11.9999 8.94269 11.8046 9.13802C11.6093 9.33335 11.2953 9.33335 10.6666 9.33335C10.0379 9.33335 9.72392 9.33335 9.52859 9.13802C9.33325 8.94269 9.33325 8.62869 9.33325 8.00002Z",
    stroke: "#697586",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdCard);
export default __webpack_public_path__ + "static/media/IdCard.321c23c69403657fb3b9ee65926511f4.svg";
export { ForwardRef as ReactComponent };